import React from 'react';
import './Text.css';
import { FaTrash, FaRedo } from 'react-icons/fa';

const Text = ({
  text,
  displayNumber,
  onDragStart,
  onDragEnd,
  onRotate,
  onDelete,
  isEditing,
}) => {
  const handleMouseDown = (e) => {
    if (isEditing && onDragStart) {
      onDragStart(e, text);
    }
  };

  const handleTouchStart = (e) => {
    if (isEditing && onDragStart) {
      onDragStart(e, text);
    }
  };

  const handleRotate = (e) => {
    e.stopPropagation();
    if (onRotate) {
      onRotate(text.id);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(text.id);
    }
  };

  return (
    <div
      className={`text-element ${isEditing ? 'editing' : ''}`}
      style={{
        left: `${text.x}px`,
        top: `${text.y}px`,
        width: `${text.width}px`,
        height: `${text.height}px`,
        transform: `rotate(${text.rotation || 0}deg)`,
        cursor: isEditing ? 'move' : 'default',
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
    >
      <div className="text-content">
        {text.content}
      </div>
      
      {isEditing && (
        <div className="text-controls">
          <button
            className="text-control-btn rotate-btn"
            onClick={handleRotate}
            title="Ротирај"
          >
            <FaRedo />
          </button>
          <button
            className="text-control-btn delete-btn"
            onClick={handleDelete}
            title="Избриши"
          >
            <FaTrash />
          </button>
        </div>
      )}
      
      
    </div>
  );
};

export default Text;